import type { WavesChart } from '../wavesChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_TOXIC } from '../builtinPulseMaps/palettes.js';
import { assembleWavesChartFromCircles } from './wavesFromCircles.js';
import audioOnsets from '../circlesBuiltinMaps/audio/nekozilla.onsets.json' with { type: 'json' };
import normalImported from '../circlesBuiltinMaps/imported/nekozilla-normal.circles.json' with { type: 'json' };
import hardImported from '../circlesBuiltinMaps/imported/nekozilla-hard.circles.json' with { type: 'json' };
import extremeImported from '../circlesBuiltinMaps/imported/nekozilla-extreme.circles.json' with { type: 'json' };

export const NEKOZILLA_WAVES_VARIANTS: Record<Variant, WavesChart> = assembleWavesChartFromCircles({
  baseSlug: 'nekozilla',
  baseTitle: "Nekozilla",
  description: "Different Heaven's heavy 128 BPM electro. Relentless wave runs across the full song.",
  difficulty: 5,
  palette: PALETTE_TOXIC,
  audioSrc: '/audio/waves/nekozilla.mp3',
  attribution: "\"Nekozilla\" by Different Heaven [NCS Release] - https://ncs.io/Nekozilla",
  mapper: "Yukiyo",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 128, offsetMs: 0, totalBeats: 131 },
    hard: { bpm: 128, offsetMs: 0, totalBeats: 131 },
    extreme: { bpm: 128, offsetMs: 0, totalBeats: 131 },
  },
});
